export default {

  /* 
    UI
  */

  SET_MENU_SIDEBAR_ACTIVE (state, data) {
    state.menuSidebarActive = data;
  },

  SET_DETAIL_SIDEBAR_ACTIVE (state, data) {
    state.detailSidebarActive = data;
  },

  /* 
    タスク（Local）
  */

  ADD_LOCAL_TASK (state, data) {
    state.localTasks.push(data);
  },

  UPDATE_LOCAL_TASK (state, data) {
    for (let key in data.status) {
      data.task[key] = data.status[key];
    }
  },

  DELETE_LOCAL_TASK (state, task) {
    state.localTasks = state.localTasks.filter(item => {
      return item !== task;
    });
  },

  RESET_LOCAL_TASKS (state) {
    state.localTasks = [];
  },

  /* 
    タスク
  */
  SET_TASKS (state, data) {
    state.tasks = data;
  },

  SET_SELECTED_TASK (state, data) {
    state.selectedTask = data;
  },

  RESET_TASKS (state) {
    state.tasks = [];
  },


  /* 
    タスク件数
  */

  SET_TOTAL_TASK_COUNT (state, data) {
    state.totalTaskCount = data;
  },

  SET_TOTAL_PROGRESS_TASK_COUNT (state, data) {
    state.totalProgressTaskCount = data;
  },

  SET_UPLOAD_PROGRESS_TASK_COUNT (state, data) {
    state.uploadProgressTaskCount = data;
  },
  SET_DOWNLOAD_PROGRESS_TASK_COUNT (state, data) {
    state.downloadProgressTaskCount = data;
  },


  /* 
    フィルタ
  */

  SET_FILTER_NAME (state, data) {
    state.filterName = data;
  },

  SET_FILTER_STATUS (state, data) {
    state.selectedFilterStatus = data;
  },

  SET_FILTER_CATEGORY (state, data) {
    state.selectedFilterCategory = data;
  },

  /* 
    ページネーション
  */
  SET_TASK_PAGE_SIZE(state, data) {
    state.taskPageSize = data;
  },

  SET_CURRENT_TASK_PAGE(state, data){
    state.currentTaskPage = data;

  },

  

  /*
    state初期化
  */
  RESET_ALL_STATE (state) {
    const defaultState = {
      tasks: [],
      localTasks: [],
      localIdNum: 0,
      totalTaskCount: 0,
      totalProgressTaskCount: 0,
      uploadProgressTaskCount: 0,
      downloadProgressTaskCount: 0,
      taskPageSize: 20,
      taskOffset: 0,
      selectedFilterStatus: null,
      selectedFilterCategory: null,
      filterName: null,
      menuSidebarActive: true,
      detailSidebarActive: false,
      selectedTask: null,
    };

    Object.assign(state, defaultState)
  }

}